import Axios from 'axios';
import React, { useEffect , useState} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin, isLogin1 } from '../util/util';
import { connect } from 'react-redux';
import { checksub } from '../Redux/Actions/Payment';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

var moment = require('moment-timezone');

const param = new URLSearchParams(window.location.search);
const f = param.get('from');
const g = param.get('to');
if (f == null && g != null) {
  localStorage.setItem('redirecturl', `/pages/call?to=${g}`);
} else if (f != null && g != null) {
  localStorage.setItem('redirecturl', `/pages/call?from=${f}&to=${g}`);
}

const PrivateRoute = ({ component: Component, isPaid, subs, ...rest }) => {
   const [isValidToken, setIsValidToken] = useState(null); // null = loading
  const currtz = useSelector(state => state.Twilio.timezone);
  const unixTimestamp = moment.tz(currtz).valueOf() / 1000;


 useEffect(() => {
    const validateToken = async () => {
      const valid = await isLogin1();
      setIsValidToken(valid);
    };
    validateToken();
  }, []);



  var subsactive = true;

  if (subs && subs.edate <= unixTimestamp) {
    console.log('true');
    subsactive = false;
    console.log('subs active is', subsactive);
  }
  if (subs && subs.edate===0) {

    subsactive = false;

  }
  if (!subsactive) {
    if (subs.status != 'Active') {
      toast.error('Subscription is not active');
    } else {
      toast.error('Please renew your subscription');
    }
  }
//   return (
   

//     <Route
//   {...rest}
//   render={props => {
//     if (process.env.REACT_APP_VERSION === "true") {
//       if (isLogin() && subsactive) {
//         return <Redirect to="/home" />

//       } else {
//         return <Component {...props} />;

//       }
//     } else if (process.env.REACT_APP_VERSION === "false") {
//       if (isLogin() && !subsactive) {
//         return <Component {...props} />;
//       } else if (isLogin() && !isPaid) {
//         return <Component {...props} />;
//       } else {
//         return <Redirect to="/home" />

//       }
//     } else {
//       return <Redirect to="/home" />

//     }
//   }}
// />


//   );
    if (isValidToken === null) {
    return <div>Loading...</div>; // or spinner if preferred
  }


return (
    <Route
      {...rest}
      render={props => {
        if (process.env.REACT_APP_VERSION === 'true') {
          if (isValidToken && subsactive) {
            return <Redirect to="/home" />;
          } else {
            return <Component {...props} />;
          }
        } else if (process.env.REACT_APP_VERSION === 'false') {
          if (isValidToken && !subsactive) {
            return <Component {...props} />;
          } else if (isValidToken && !isPaid) {
            return <Component {...props} />;
          } else {
            return <Redirect to="/home" />;
          }
        } else {
          return <Redirect to="/home" />;
        }
      }}
    />
  );

};

const mapeStateToProps = state => ({
  isPaid: state.auth.isPaid,
  isAuthenticated: state.auth.isAuthenticated,
  subs: state.auth.subs
});

export default connect(
  mapeStateToProps,
  { checksub }
)(PrivateRoute);
